(function (Drupal, once) {
    'use strict';

    Drupal.behaviors.polygonSlider = {
        attach: function (context) {
            const selector = once('polygon-slider', '.polygon-slider .swiper', context);
            if (!selector || !selector.length) return;

            if (typeof Swiper === 'undefined') {
                console.warn('Swiper library not loaded');
                return;
            }

            const POLYGON_OPTIONS = {
                slidesPerView: 'auto',
                spaceBetween: -100,
                loop: true,
                centeredSlides: true,
                breakpoints: {
                    992: {
                        slidesPerView: 'auto',
                        centeredSlides: false,
                    },
                    1200: {
                        spaceBetween: 0,
                        slidesPerView: 'auto',
                        loop: false,
                        centeredSlides: false,
                        enabled: false
                    }
                },
                on: {
                    breakpoint: function (swiper) {
                        if (window.innerWidth >= 1200) {
                            swiper.disable();
                            swiper.el.classList.add('swiper-disabled');
                        } else {
                            swiper.enable();
                            swiper.el.classList.remove('swiper-disabled');
                            swiper.update();
                        }
                    }
                }
            };

            selector.forEach((slider) => {
                if (!slider || slider.dataset.swiperInit === 'true' || slider._swiper) return;

                const options = Object.assign({}, POLYGON_OPTIONS, {
                    pagination: { el: slider.querySelector('.swiper-pagination') || undefined, clickable: true }
                });

                try {
                    const instance = new Swiper(slider, options);
                    slider._swiper = instance;
                    slider.dataset.swiperInit = 'true';
                    slider.classList.add('is-swiper-active');

                    if (window.innerWidth >= 1200) {
                        instance.disable();
                        slider.classList.add('swiper-disabled');
                    }
                } catch (e) {
                    console.error('Failed to initialize polygon slider', e);
                }
            });
        }
    };

})(Drupal, once);